import aivshuman from "../assets/aivshuman-hero.webp";
import chatgptAstrologyHero from "../assets/chatgpt-astrology-hero.webp";
import manglikDoshaHero from "../assets/manglik-dosha-hero.webp";
import diwali2026Hero from "../assets/diwali-2026-hero.webp";
import chatgptSeKundliHero from "../assets/chatgpt-se-kundli-hero.webp";
import karwaChauth2026Hero from "../assets/karwa-chauth-2026-hero.webp";
import shadiMuhurat2026Hero from "../assets/shadi-muhurat-2026-hero.webp";
import november2026RashifalHero from "../assets/november-2026-rashifal-hero.webp";
import dhanteras2026Hero from "../assets/dhanteras-2026-hero.webp";
import weeklySep28Hero from "../assets/weekly-horoscope-sep28-hero.webp";
import weeklyOct26Hero from "../assets/weekly-horoscope-oct26-hero.webp";
import weeklyNov2Hero from "../assets/weekly-horoscope-nov2-hero.webp";
import kundliForNrisHero from "../assets/kundli-for-nris-hero.webp";
import diwali2026MuhuratHero from "../assets/diwali-2026-muhurat-hero.webp";
import usBornDesiHero from "../assets/us-born-desi-hero.webp";
import manglikNriHero from "../assets/manglik-nri-hero.webp";
import kundliMatchingHero from "../assets/kundli-matching-hero.webp";
import loveCalculatorHero from "../assets/love-calculator-hero.webp";
import kundliKaiseDekheHero from "../assets/kundli-kaise-dekhe-hero.webp";
import sadeSati2026Hero from "../assets/sade-sati-2026-27-hero.webp";
import manglikBhangHero from "../assets/manglik-dosha-bhang-hero.webp";
import janamNakshatraHero from "../assets/janam-nakshatra-hero.webp";
import kitneGunHero from "../assets/kitne-gun-milne-chahiye-hero.webp";
import devUthani2026Hero from "../assets/dev-uthani-ekadashi-2026-hero.webp";
import mulankHero from "../assets/mulank-kaise-nikale-hero.webp";
import mahadashaKaiseHero from "../assets/mahadasha-kaise-dekhe-hero.webp";
import weeklyNov9Hero from "../assets/weekly-horoscope-nov9-hero.webp";
import img2 from "../assets/img2.webp";
import img3 from "../assets/img3.webp";
import img4 from "../assets/img4.webp";
import img5 from "../assets/img5.webp";

export interface Article {
  id: number;
  title: string;
  desc: string;
  img: string;
  btn: string;
  tag?: string;
  date?: string;
  /** Required. A card with no destination used to silently navigate to "/". */
  path: string;
}

/* Single source of truth for the written articles. /blog renders them in full
   and the homepage strip shows the same set, so they cannot drift apart.
   Newest first. Every entry MUST have a `path`. */
export const articles: Article[] = [
  { id: 33, title: "Weekly Horoscope 09-15 Nov: Predictions For 12 Zodiac Signs", desc: "Mercury turns direct on Nov 13 and Venus on Nov 14, while Mars leaves Cancer to join Jupiter in Leo. Sign-by-sign guidance for the week of Bhai Dooj and Chhath.", img: weeklyNov9Hero, btn: "Read More", tag: "Weekly Horoscope", date: "November 8, 2026", path: "/blog/weekly-horoscope-nov-9-15-2026" },
  { id: 25, title: "Kundli Kaise Dekhe: Step by Step Asaan Guide", desc: "Kundli kaise dekhe, step by step: North aur South Indian chart, lagna, 12 bhav ka matlab, rashi number, grah aur dasha. Pehli baar kundli padhne waalon ke liye.", img: kundliKaiseDekheHero, btn: "Read More", tag: "Kundli", date: "November 3, 2026", path: "/blog/kundli-kaise-dekhe" },
  { id: 26, title: "Sade Sati 2026-27: Kin Rashiyon Par, Kab Tak", desc: "Shani Meen rashi me hai, isliye sade sati Kumbh, Meen aur Mesh par hai. 3 June 2027 ke Shani gochar ke baad kaun sa charan kis rashi par, poori timeline.", img: sadeSati2026Hero, btn: "Read More", tag: "Gochar", date: "November 3, 2026", path: "/blog/sade-sati-2026-27" },
  { id: 27, title: "Manglik Dosha Bhang: Kab Cancel Hota Hai Dosha", desc: "Manglik dosha bhang ke niyam: Mangal swarashi ya uchch, Guru ki drishti, dono manglik aur sign-house exceptions. Kaun sa niyam kitna pakka, check ka kram.", img: manglikBhangHero, btn: "Read More", tag: "Kundli Matching", date: "November 3, 2026", path: "/blog/manglik-dosha-bhang" },
  { id: 28, title: "Janam Nakshatra Kaise Jaane: Pada Aur Swami", desc: "Janam nakshatra kaise jaane: Chandrama ki degree se nakshatra aur pada nikalna, 27 nakshatron ki list swami ke saath, aur dasha aur gun milan me iska kaam.", img: janamNakshatraHero, btn: "Read More", tag: "Nakshatra", date: "November 3, 2026", path: "/blog/janam-nakshatra-kaise-jaane" },
  { id: 29, title: "Kitne Gun Milne Chahiye? 18/36 Ka Asli Matlab", desc: "Shadi ke liye kitne gun milne chahiye? 36 me se 18 ka niyam, score ka matlab, aur kyun Nadi ya Bhakoot ka zero total se bhaari hai, exceptions ke saath.", img: kitneGunHero, btn: "Read More", tag: "Kundli Matching", date: "November 3, 2026", path: "/blog/kitne-gun-milne-chahiye" },
  { id: 30, title: "Dev Uthani Ekadashi 2026: Shadi Season Kab Se", desc: "Dev Uthani Ekadashi 2026 Friday 20 November ko hai, Tulsi Vivah 21 ko. Chaturmas ke baad shadi season kab khulta hai, Nov-Dec ki vivah dates aur Kharmas kab se.", img: devUthani2026Hero, btn: "Read More", tag: "Festivals", date: "November 3, 2026", path: "/blog/dev-uthani-ekadashi-2026-shadi-season" },
  { id: 31, title: "Mulank Kaise Nikale: 1 Se 9 Tak Ka Matlab", desc: "Mulank kaise nikale: janam tareekh ke ank jod kar 1 se 9 ka number, har mulank ka swami grah aur swabhav, aur mulank-bhagyank ka farak, examples ke saath.", img: mulankHero, btn: "Read More", tag: "Numerology", date: "November 3, 2026", path: "/blog/mulank-kaise-nikale" },
  { id: 32, title: "Mahadasha Kaise Dekhe: Apni Dasha Samjhein", desc: "Mahadasha kaise dekhe: Vimshottari ke 120 saal, nau grahon ka kram aur avadhi, janam nakshatra se pehli dasha, antardasha ka hisaab aur apni dasha padhna.", img: mahadashaKaiseHero, btn: "Read More", tag: "Dasha", date: "November 3, 2026", path: "/blog/mahadasha-kaise-dekhe" },
  /* ids 15 and 14: id 13 is reserved by the Diwali USA post built on the
     usa-batch-1 branch, so these skip it to avoid a duplicate-id collision
     when both branches merge. */
  {
      id: 21,
      title: "Weekly Horoscope Nov 2-8, 2026: Diwali Week for All 12 Signs",
      desc: "Sun, retrograde Mercury and retrograde Venus crowd Libra, Mars sits debilitated in Cancer and Jupiter opens a new chapter in Leo. Sign-by-sign guidance for the Diwali week.",
      img: weeklyNov2Hero,
      btn: "Read More",
      tag: "Weekly Horoscope",
      date: "November 1, 2026",
      path: "/blog/weekly-horoscope-nov-2-8-2026",
    },
  {
    id: 24,
    title: "Dhanteras 2026: Rashi Ke Hisaab Se Kya Kharidein",
    desc: "Dhanteras Friday 6 November ko hai. Apni rashi ke swami grah ke hisaab se kya kharidna shubh mana jaata hai: sona, chandi, taamba, bartan ya jhadu. Puri rashi-wise list.",
    img: dhanteras2026Hero,
    btn: "Read More",
    tag: "Festivals",
    date: "October 28, 2026",
    path: "/blog/dhanteras-2026-rashi-shopping",
  },
  {
    id: 22,
    title: "Weekly Horoscope 26 Oct-01 Nov: Predictions For 12 Zodiac Signs",
    desc: "Mercury freshly retrograde joins retrograde Venus and the Sun in Libra, Jupiter spends its last exalted days in Cancer, and Karwa Chauth falls on Thursday. Sign-by-sign predictions.",
    img: weeklyOct26Hero,
    btn: "Read More",
    tag: "Weekly Horoscope",
    date: "October 26, 2026",
    path: "/blog/weekly-horoscope-26-oct-1-nov-2026",
  },
  {
    id: 20,
    title: "Diwali 2026 Kab Hai: Date, Lakshmi Puja Muhurat Aur 5 Din Ka Calendar",
    desc: "Diwali 2026 Sunday, 8 November ko hai. Delhi se Chennai tak Lakshmi Puja ka approximate muhurat, Dhanteras ki kharidari ka time, aur Dhanteras se Bhai Dooj tak ka din-wise calendar.",
    img: diwali2026MuhuratHero,
    btn: "Read More",
    tag: "Festivals",
    date: "October 24, 2026",
    path: "/blog/diwali-2026-puja-muhurat",
  },
  {
    id: 17,
    title: "Kundli for NRIs: Birth Time Abroad and Time Zone Accuracy",
    desc: "Born in the US, UK or Gulf? Your kundli is computed for that place and time zone, not India's. The DST trap, what a US birth certificate gives you, and how to match kundlis across continents.",
    img: kundliForNrisHero,
    btn: "Read More",
    tag: "Kundli",
    date: "October 24, 2026",
    path: "/blog/kundli-for-nris",
  },
  {
    id: 18,
    title: "Vedic Birth Chart for US-Born Desis: Why Your Sign Changes",
    desc: "Grew up a Leo, but your parents' pandit says Cancer? The sidereal shift explained, what a kundli gives you that a sun-sign app cannot, and how to cast yours with an American birth certificate.",
    img: usBornDesiHero,
    btn: "Read More",
    tag: "Kundli",
    date: "October 24, 2026",
    path: "/blog/birth-chart-us-born-desis",
  },
  {
    id: 19,
    title: "Manglik Dosha in NRI Marriages: Check Before You Panic",
    desc: "A rishta stalls because someone said manglik. How the dosha is actually checked, the cancellation rules families forget, and how NRI couples verify it online in minutes.",
    img: manglikNriHero,
    btn: "Read More",
    tag: "Kundli Matching",
    date: "October 24, 2026",
    path: "/blog/manglik-dosha-nri-marriage",
  },
  {
    id: 16,
    title: "November 2026 Rashifal: Sabhi 12 Rashiyon Ka Masik Rashifal",
    desc: "12 ko Mangal Simha mein, 13-14 ko Budh-Shukr margi, 16 ko Surya Vrishchik mein, 19 se shadi season aur Shani Meena mein vakri. Har rashi ka November 2026 ka seedha haal, ek hi post mein.",
    img: november2026RashifalHero,
    btn: "Read More",
    tag: "Rashifal",
    date: "October 23, 2026",
    path: "/blog/november-2026-rashifal",
  },
  {
    id: 15,
    title: "Shadi Muhurat November December 2026: Shubh Vivah Dates List",
    desc: "Devuthani Ekadashi 20 November 2026 se shadi ka season khulta hai. November aur December ki shubh vivah dates nakshatra ke saath, aur date pakki karne se pehle kundli me kya check karein.",
    img: shadiMuhurat2026Hero,
    btn: "Read More",
    tag: "Muhurat",
    date: "October 22, 2026",
    path: "/blog/shadi-muhurat-nov-dec-2026",
  },
  {
    id: 13,
    title: "Diwali 2026 in the USA: Dates, Puja Times by City & Karva Chauth",
    desc: "Diwali 2026 falls on Sunday, 8 November in the US too. How Lakshmi Puja timing works in American timezones, sunset guidance for seven metros, Karva Chauth, and the wedding dates that follow.",
    img: diwali2026Hero,
    btn: "Read More",
    tag: "Festivals",
    date: "October 21, 2026",
    path: "/blog/diwali-2026-usa",
  },
  {
    id: 14,
    title: "Karwa Chauth 2026: Date, City-Wise Moonrise Time Aur Puja Muhurat",
    desc: "Karwa Chauth 2026 Thursday, 29 October ko hai. Delhi se Bengaluru tak chand nikalne ka approximate time, puja muhurat, vrat ki poori vidhi aur chand ka aapki kundli se rishta.",
    img: karwaChauth2026Hero,
    btn: "Read More",
    tag: "Festivals",
    date: "October 20, 2026",
    path: "/blog/karwa-chauth-2026",
  },
  {
    id: 12,
    title: "ChatGPT Se Kundli Aur Palm Reading: Viral AI Trends Ka Sach",
    desc: "Palm photo upload, copy-paste kundli prompt, shaadi kab hogi waali reels. 2026 ke viral AI astrology trends humne khud test kiye: kya sahi hai, kya guess, aur palm photo waala risk jo koi reel nahi batati.",
    img: chatgptSeKundliHero,
    btn: "Read More",
    tag: "AI Astrology",
    date: "October 18, 2026",
    path: "/blog/chatgpt-se-kundli",
  },
  {
    id: 11,
    title: "Diwali 2026 Rashifal: What Lakshmi Puja Week Brings for Your Sign",
    desc: "Diwali 2026 falls on Sunday, 8 November. The five festive days with dates, what the Kartik Amavasya sky means, and a short festive rashifal for all 12 signs.",
    img: diwali2026Hero,
    btn: "Read More",
    tag: "Festivals",
    date: "October 16, 2026",
    path: "/blog/diwali-2026-rashifal",
  },
  {
    id: 10,
    title: "Manglik Dosha: What It Actually Means and When It Cancels",
    desc: "Mars in six houses from the lagna makes a chart manglik. The placements that matter, the cancellations the classical texts recognise, and the truth about the age-28 belief.",
    img: manglikDoshaHero,
    btn: "Read More",
    tag: "Kundli Matching",
    date: "October 14, 2026",
    path: "/blog/manglik-dosha-explained",
  },
  {
    id: 9,
    title: "ChatGPT Astrology: Can ChatGPT Read Your Kundli?",
    desc: "We gave ChatGPT a real birth chart and checked every line it produced. Where a general chatbot helps, where it quietly invents planetary positions, and what to use instead.",
    img: chatgptAstrologyHero,
    btn: "Read More",
    tag: "AI Astrology",
    date: "October 12, 2026",
    path: "/blog/ai-astrology-vs-chatgpt",
  },
  {
    id: 23,
    title: "Weekly Horoscope 28 Sep-4 Oct: Predictions for 12 Zodiac Signs",
    desc: "Pitru Paksha continues, Venus turns retrograde in Libra on Saturday October 3, Jupiter rides exalted in Cancer and Saturn stays retrograde in Pisces. What the week holds for your sign.",
    img: weeklySep28Hero,
    btn: "Read More",
    tag: "Weekly Horoscope",
    date: "September 28, 2026",
    path: "/blog/weekly-horoscope-28-sep-4-oct-2026",
  },
  {
    id: 8,
    title: "Kundli Matching: How Gun Milan Actually Works",
    desc: "The 36 gunas explained: what each of the eight kootas measures, why swapping the two charts changes the score, and what Nadi and Bhakoot cancellations really mean.",
    img: kundliMatchingHero,
    btn: "Read More",
    tag: "Kundli Matching",
    date: "September 3, 2026",
    path: "/blog/kundli-matching-gun-milan-explained",
  },
  {
    id: 7,
    title: "Love Calculator: What the Score Actually Means",
    desc: "Most love calculators only read the letters in two names. Here is what Vedic astrology checks instead, and how to read a compatibility score honestly.",
    img: loveCalculatorHero,
    btn: "Read More",
    tag: "Compatibility",
    date: "September 3, 2026",
    path: "/blog/love-calculator-what-the-score-means",
  },
  {
    id: 6,
    title: "Is AI Capable of Predicting Your Future? AI Astrology vs Human Astrology",
    desc: "An honest look at where AI astrology beats a human astrologer, where it does not, and how to get the most accurate reading from your own birth chart.",
    img: aivshuman,
    btn: "Read More",
    tag: "AI Astrology",
    date: "August 23, 2026",
    path: "/blog/ai-astrology-vs-human-astrology",
  },
  {
    id: 2,
    title: "The Fire Signs: Aries, Leo, and Sagittarius Personality Traits",
    desc: "Explore the passionate and dynamic nature of fire signs. Discover their strengths, challenges, and how they navigate relationships and career paths.",
    img: img2,
    btn: "Read More",
    tag: "Zodiac Signs",
    date: "December 15, 2024",
    path: "/blog/fire-signs-in-vedic-astrology",
  },
  {
    id: 3,
    title: "Harnessing Full Moon Energy for Manifestation and Release",
    desc: "Learn powerful rituals and practices to align with lunar cycles. Transform your intentions into reality using ancient moon magic wisdom.",
    img: img3,
    btn: "Read More",
    tag: "Moon Phases",
    date: "December 12, 2024",
    path: "/blog/full-moon-purnima-astrology",
  },
  {
    id: 5,
    title: "Understanding Planetary Transits and Their Life Impact",
    desc: "Learn how planetary movements influence your daily life, relationships, and major life decisions. Master the art of cosmic timing.",
    img: img5,
    btn: "Read More",
    tag: "Planetary",
    date: "December 8, 2024",
    path: "/blog/planetary-transits-explained",
  },
];
